<template>
	<div class="dropdown-list">
		<div
			v-for="child in value"
			:key="child.value"
			class="dropdown-item"
		>
			<div
				class="form-check"
				@click.stop.prevent="Select(child)"
			>
				<input
					type="checkbox"
					class=""
					:id="child.value"
					:name="child.value"
					:checked="child.checked"
					hidden
				/>
				<label
					class="form-check-label"
					:for="child.value"
					@click.stop.prevent="Select(child)"
				>
				</label>
				<span
					class="flex-1 text-uppercase"
					:class="`level-${level}`"
				>
					{{ child.label }}
				</span>
				<template v-if="child.children?.length > 0">
					<i
						class="fas expand-icon"
						:class="{
							'fa-chevron-right': !child.opened,
							'fa-chevron-down': child.opened,
						}"
						@click.stop.prevent="Open(child)"
					></i>
				</template>
			</div>

			<DropdownList
				v-if="child.opened && child.children?.length > 0"
				v-model="child.children"
				:level="level + 1"
			/>
		</div>
	</div>
</template>

<script>
	import { useEachRecursively } from '@/composables'

	export default {
		name: 'DropdownList',
		props: {
			value: {
				type: Array,
				default: () => [],
			},
			level: {
				type: Number,
				default: 1,
			},
		},

		data() {
			return {
				newValue: {
					opened: false,
					checkedAll: false,
					children: [],
				},
			}
		},
		computed: {
			selecteds() {
				const selecteds = []

				useEachRecursively(this.newValue, child => {
					if (child.checked) selecteds.push(child.value)
				})

				return selecteds
			},
		},
		watch: {
			value: {
				handler(newValue) {
					this.newValue = newValue
				},
				immediate: true,
				deep: true,
			},
			selecteds: {
				handler(newValue) {
					this.$emit('selecteds', newValue)
				},
				immediate: true,
			},
		},
		methods: {
			Open(child) {
				child.opened = !child.opened
				this.$emit('change', this.newValue)
			},
			Select(child) {
				child.checked = !child.checked

				if (child.children?.length > 0) {
					useEachRecursively(child.children, subChild => {
						subChild.checked = child.checked
					})
				}

				this.$emit('change', this.newValue)
			},
		},
	}
</script>

<style lang="scss" scoped>
	.expand-icon {
		padding: 0rem 0.8rem;
		color: var(--fontColor);
		font-size: 1.5rem;
	}
</style>
